// Utilities
import { lazy } from "react";
import { retry } from "@ms/uno-utilities/lib/local/RetryUtilities";
export const GroundingResourcesDialogContainerLazyLoader = ()=>retry(()=>import(/* webpackChunkName: "planner-groundingresourcesdialogcontainer" */ "./GroundingResourcesDialogContainer")).then((bundle)=>{
        return {
            default: bundle.GroundingResourcesDialogContainer
        };
    });
export const LazyGroundingResourcesDialogContainer = /*#__PURE__*/ lazy(GroundingResourcesDialogContainerLazyLoader);
